import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './fornecedorForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './fornecedorActions';

import {
    getLista as getListaCidade
} from '../cidade/cidadeActions';

const columns = [
    {
        field: 'razao_social',
        type: 'text'
    },
    {
        field: 'cpf_cnpj',
        type: 'cpf',
        formatter: row => row.cpf || row.cnpj
    },
    {
        field: 'nome_cidade',
        type: 'text'
    }
];

const Fornecedor = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'razao_social',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
        props.getListaCidade();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return {
                field,
                direction
            };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.razao_social || ''}
                ${item.nome_fantasia || ''}
                ${item.cpf || ''}
                ${item.cnpj || ''}
                ${item.nome_cidade || ''}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(p => p.trim())
                .every(p => texto.includes(p.trim()));
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item
                }))}
                name='Fornecedores'
            >
                <ExcelColumn label='Nome / Razão Social' value='razao_social' />
                <ExcelColumn label='Nome Fantasia' value='nome_fantasia' />
                <ExcelColumn label='CNPJ' value='cnpj' />
                <ExcelColumn label='CPF' value='cpf' />
                <ExcelColumn label='IE' value='ie' />
                <ExcelColumn label='Endereço' value='endereco' />
                <ExcelColumn label='Número' value='numero' />
                <ExcelColumn label='Complemento' value='complemento' />
                <ExcelColumn label='Bairro' value='bairro' />
                <ExcelColumn label='CEP' value='cep' />
                <ExcelColumn label='Cidade' value='nome_cidade' />
                <ExcelColumn label='Usuário da Inclusão' value='nome_usuario_inclusao' />
                <ExcelColumn label='Usuário da Alteração' value='nome_usuario_alteracao' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div style={{ marginTop: 8, width: 270 }}>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({
                                        tipo_pessoa: 'juridica',
                                        contatos: [
                                            {
                                                id: null,
                                                nome: '',
                                                celular: '',
                                                email: ''
                                            }
                                        ]
                                    });
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Fornecedores'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='razao_social'
                                    label='Nome / Razão Social'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='cpf_cnpj'
                                    label='CPF / CNPJ'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nome_cidade'
                                    label='Cidade'
                                    width={200}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.razao_social}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.cpf || item.cnpj}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.nome_cidade}
                                    </Td>

                                    <Td alignCenter minWidth={130} maxWidth={130}>
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible={true}
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastro', {
                                                    ...item
                                                });

                                                props.initForm({
                                                    ...item
                                                });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible={true}
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', {
                                                    ...item
                                                });

                                                props.initForm({
                                                    ...item
                                                });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' ? (
                <Form onSubmit={props.salvar} />
            ) : null}

            {props.modoTela === 'exclusao' ? (
                <Form excluir onSubmit={props.excluir} />
            ) : null}

            {props.modoTela === 'lista' ? renderLista() : null}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.fornecedor.modoTela,
    aguardando: state.fornecedor.aguardando,
    lista: state.fornecedor.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getListaCidade
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Fornecedor);